import { render, staticRenderFns } from "./ModalIngreso.vue?vue&type=template&id=c4d0349a"
import script from "./ModalIngreso.vue?vue&type=script&lang=js"
export * from "./ModalIngreso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports